<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col cols="12" md="8">
        <v-card height="100%" flat>
          <div class="text-center pt-4">
            <h2>{{title}}</h2>
            <h3 class="font-italic">
              ( Ngày   {{date.d}}   tháng    {{date.m}}    năm    {{date.y}}   )
            </h3>
          </div>
          <v-card-text class="pa-0">
            <v-toolbar flat>
              
              <!-- start: makeloading -->
              <v-chip 
                v-if="periodLoading && !prevDate"
                link
                class="px-4 mr-2"
              >
                <v-progress-circular
                  :size="20"
                  :width="1"
                  indeterminate
                ></v-progress-circular>
              </v-chip>

              <v-chip 
                v-if="periodLoading && !nextDate"
                link
                class="px-4 mr-2"
              >
                <v-progress-circular
                  :size="20"
                  :width="1"
                  indeterminate
                ></v-progress-circular>
              </v-chip>
              <!-- end: makeloading -->
              
              <v-tooltip top v-if="prevDate">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip 
                    link
                    v-bind="attrs" 
                    v-on="on"
                    class="px-4 mr-2"
                    :to="{ name: 'MarketView', params: { date: parseDate(prevDate) }}"
                  >
                    <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-chevron-left</v-icon> 
                    <span v-if="$vuetify.breakpoint.lgAndUp">Kỳ Trước</span>
                  </v-chip>
                </template>
                <span>Ngày {{prevDate}}</span>
              </v-tooltip>
              <v-tooltip top v-if="nextDate">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip 
                    link
                    v-bind="attrs" 
                    v-on="on"
                    class="px-4"
                    :to="{ name: 'MarketView', params: { date: parseDate(nextDate) }}"
                  >
                    <span v-if="$vuetify.breakpoint.lgAndUp">Kỳ Sau</span> 
                    <v-icon :right="$vuetify.breakpoint.lgAndUp">mdi-chevron-right</v-icon>
                  </v-chip>
                </template>
                <span>Ngày {{nextDate}}</span>
              </v-tooltip>
              <v-spacer/>
              <v-text-field
                v-model="keyword"
                append-icon="mdi-magnify"
                label="Tìm tên mặt hàng"
                single-line
                hide-details
                class="market-search shrink mr-4"
                rounded
                clearable
                dense
              />
              <v-chip 
                outlined
                class="px-8 mr-2"
              >
                <v-progress-circular 
                  v-if="countViewLoading" 
                  indeterminate size="16" 
                  :width="1"
                />
                <template v-else>
                  <v-icon small left>mdi-eye</v-icon>
                  <span> {{countView}}</span>
                </template>
              </v-chip>
              <v-chip 
                outlined
                class="px-8"
              >
                <v-progress-circular 
                  v-if="countDownloadLoading" 
                  indeterminate size="16" 
                  :width="1"
                />
                <template v-else>
                  <v-icon small left>mdi-download-outline</v-icon>
                  <span>{{countDownload}}</span>
                </template>
              </v-chip>
            </v-toolbar>
            <v-data-table
              dense
              disable-sort
              :headers="headers"
              hide-default-footer
              disable-pagination
              :items="prices"
              :search="keyword"
              item-key="id"
              group-by="market_product.product_type.name"
              class="px-4 pt-4"
              id="market_table"
              height="100%"
            >
              <template v-slot:group.header="{items, isOpen, toggle}">
                <th colspan="4" class="tbheader">
                  <v-icon @click="toggle"
                    >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                  </v-icon>
                  {{ items[0].market_product.product_type ? items[0].market_product.product_type.name : '' }}
                </th>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.market_product.name }}</td>
                  <td class="text-center">{{ item.market_product.don_vi_tinh }}</td>
                  <td class="text-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <template v-if="item.l_price">
                            {{ item.l_price | currency }}
                            <span v-html="priceStatusNew(item.l_price, item.prev_l_price, item, 'lp')"/>
                          </template>
                           - 
                          <template v-if="item.h_price">
                            {{ item.h_price | currency }}
                            <span v-html="priceStatusNew(item.h_price, item.prev_h_price, item)"/>
                          </template>
                        </div>
                      </template>
                      <span>
                        So với ngày {{item.prev_date}} ({{ item.prev_l_price | currency }} - {{ item.prev_h_price | currency }})
                      </span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-btn icon @click="showThongKe(item)">
                      <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-divider class="my-4 mx-6"/>
            <v-row class="text-center">
              <v-col>
                <span class="text-uppercase font-weight-bold">
                  Nguồn: Chi cục Quản lý chất lượng Nông lâm sản và Thủy sản.
                </span>
              </v-col>
            </v-row>
            <v-row class="text-center my-4">
              <v-col>
                <v-btn
                  large
                  color="primary"
                  dark
                  @click="exportData()"
                  :loading="exportLoading"
                >
                  Tải về bảng giá
                </v-btn>
                <div class="mt-1" v-if="exportLoading">
                  Đang tải về, vui lòng chờ giây lát!
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="4">
        <MarketRelated :date="$route.params.date"/>
      </v-col>
    </v-row>
    <MarketChart
      :showDialog="chartDialog"
      :matHangShowChart="matHangShowChart"
      :namShowChart="namShowChart"
      :date="$route.params.date"
      @cancelled="onChartCancelled"
    />
  </v-container>
</template>
<script>
  import MarketChart from '@/views/public/markets/MarketChart';
  import SystemSevice from '@/services/System';
  import FileSevice from '@/services/File';
  import { mapActions } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import MarketRelated from './MarketRelated.vue';
  export default {
    components: { 
      MarketChart,
      BaseBreadcrumbs,
      MarketRelated
    },
    data: () => ({
      tab: 0,
      loading: false,
      periodLoading: false,
      chartDialog: false,
      crumbs: [],
      prices: [],
      keyword: '',
      search: {
        thang: '',
        nam: '',
        loai: '',
      },
      headers: [
        { text: 'Tên mặt hàng', value: 'market_product.name', class: "font-weight-bold" },
        { text: 'Đơn vị tính', value: 'market_product.don_vi_tinh', align: 'center', class: "font-weight-bold" },
        { text: 'Giá tham khảo (đồng)', value: 'l_price', align: 'center', class: "font-weight-bold" }
      ],
      title: "THÔNG TIN GIÁ CẢ CÁC SẢN PHẨM NÔNG SẢN, VẬT TƯ NÔNG NGHIỆP",
      date: {
        d: "",
        m: "",
        y: ""
      },
      matHangShowChart: {},
      namShowChart: null,
      relatedLoading: false,
      exportLoading: false,
      prevDate: '',
      nextDate: '',
      countDownload: 0,
      countView: 0,
      countViewLoading: false,
      countDownloadLoading: false,
    }),
    watch: {
      "$route.params.date": function() {
        this.getMarketPrices();
        this.getPrevAndNextDate();
        this.setDate();
        this.downloadCount();
        // save count view
        SystemSevice.setSiteViewLocal({
          name: `MarketView@${this.$route.params.date}`,
        });
        this.viewCount();
      }
    },
    mounted () {
      this.getMarketPrices();
      this.getPrevAndNextDate();
      this.setDate();
      this.downloadCount();
      // save count view
      SystemSevice.setSiteViewLocal({
        name: `MarketView@${this.$route.params.date}`,
      });
      this.viewCount();
    },
    methods: {
      ...mapActions([
        'openSnackbar',
        'getLoader'
      ]),
      setDate(){
        let p_date = this.$route.params.date;
        this.date.d = p_date.substring(0,2);
        this.date.m = p_date.substring(2,4);
        this.date.y = p_date.substring(4,8);
        this.crumbs = [
          {
            text: 'Trang chủ',
            disabled: false,
            href: '/',
          },
          {
            text: 'Giá nông sản',
            disabled: false,
            href: '/market-price',
          },
          {
            text: `Giá cả ngày ${this.date.d}/${this.date.m}/${this.date.y}`,
            disabled: true
          }
        ];
      },
      getMarketPrices(){
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/get-market-by-date/${app.$route.params.date}`)
          .then(response => {
            app.prices = response.data;
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getPrevAndNextDate(){
        const app = this;
        app.periodLoading = true;
        axios.get(`api/v1/public/get-prev-and-next-date/${this.$route.params.date}`)
          .then(response => {
            let data = response.data;
            app.prevDate = data.prev_date;
            app.nextDate = data.next_date;
            app.periodLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            app.periodLoading = false;
          });
      },
      parseDate(d){
        // convert to format: ddmmyyyy
        if(!d) return null;
        return d.replaceAll('/', '');
      },
      showThongKe(item){
        this.matHangShowChart=item;
        this.namShowChart=this.$route.params.date.substring(4,8);
        this.chartDialog = true;
      },
      downloadCount(){
        this.countDownloadLoading=true;
        axios.get(`api/v1/public/get-site-detail-counter/MarketExport@${this.$route.params.date}`)
          .then(response => {
            this.countDownload=response.data;
            this.countDownloadLoading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      viewCount(){
        this.countViewLoading=true;
        axios.get(`api/v1/public/get-site-detail-counter/MarketView@${this.$route.params.date}`)
          .then(response => {
            this.countView=response.data;
            this.countViewLoading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      onChartCancelled () {
        this.chartDialog = false;
      },
      priceStatus(now, prev) {
        let _now = now ? parseInt(now) : 0,
            _prev = prev ? parseInt(prev) : 0,
            _diff = 0;
        if(!_prev) return null;
        _diff = _now-_prev;
        let val = ((_diff/prev)*100).toFixed(2);
        if(val == 0) return `(ổn định)`;
        if(val < 0) {
          return `(<span class="red--text">giảm ${this.shortPrice(Math.abs(_diff))}, &#8595;<small><b>${Math.abs(val)}%</b></small></span>)`;
        }
        return `(<span class="green--text">tăng ${this.shortPrice(_diff)}, &#8593;<small><b>${val}%</b></small></span>)`;
      },
      priceStatusNew(now, prev, item, type='') {
        let _now = now ? parseInt(now) : 0,
            _prev = prev ? parseInt(prev) : 0,
            _diff = 0;
        if(!_prev) return null;
        _diff = _now-_prev;
        let val = ((_diff/prev)*100).toFixed(2);
        if(val == 0){
          if(this.checkTheSame(item) && type == 'lp'){
            return ``;
          } else {
            return `(ổn định)`;
          }
        }
        if(val < 0) {
          return `(<span class="red--text">giảm ${this.shortPrice(Math.abs(_diff))}, &#8595;<small><b>${Math.abs(val)}%</b></small></span>)`;
        }
        return `(<span class="green--text">tăng ${this.shortPrice(_diff)}, &#8593;<small><b>${val}%</b></small></span>)`;
      },
      toOtherPrice(date){
        this.$router.push({name:'MarketView',params:{d:this.parseDate(date)}});
      },
      shortPrice: (value) => {
        if(parseInt(value) >= 1000){
          return (value/1000).toString() + 'k đồng';
        } else {
          return value + ' đồng';
        }
      },
      checkTheSame(item){
        if(!item.prev_l_price || !item.prev_l_price)
          return false;

        let _diff_l = item.l_price - item.prev_l_price;
        let _diff_h = item.h_price - item.prev_h_price;
        if( _diff_l == 0 &&  _diff_h == 0 ) {
          return true;
        }
        return false;
      },
      exportData() {
        const app =this;
        app.exportLoading=true;
        axios.get(
          `api/v1/public/market-export/${app.$route.params.date}`,
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `${app.$route.params.date}.xlsx`);
            app.exportLoading=false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải về thành công!'
            });
            SystemSevice.setSiteViewLocal({
              name: `MarketExport@${app.$route.params.date}`,
            });
          })
          .catch(function (error) {
            console.log(error)
            app.exportLoading=false;
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>
<style>
.basil {
  background-color: #FFFBE6 !important;
}
.basil--text {
  color: #356859 !important;
}
#market_table thead tr th{
  font-size: 14px;
  font-weight: 500;
}
.v-row-group__header{
  background-color: #00796b !important;
  color: #fff;
}
.mrelated .thumb{
  width: 150px;
  overflow: hidden;
}
.mrelated .thumb .thtop{
  background: rgb(195 189 189);
  padding: 18px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  height: 50%;
}
.mrelated .thumb .thbot{
  background: rgb(205 54 54);
  padding: 10px;
  color: rgb(255, 255, 255);
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  height: 50%;
}
.market-search .v-input__control {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 19px;
  padding: 2px 0px;
}
.market-search .v-input__control .v-input__slot {
  padding-right: 5px;
  padding-left: 15px;
}
</style>